import { AbstractControl } from '@angular/forms';
import { ErrorMessage } from '../constants/error-message.constants';
import { Regex } from '../constants/regex.constants';

export function emailValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value === '' || control.value === null) {
        return null;
    } else if (!Regex.Email.test(control.value)) {
        return {
            email: { message: ErrorMessage.email }
        };
    }

    return null;
}
